import { Container, Button, SFXS } from "@orbital/games-frontend-library";
import Risks from "./Risks";
import Rows from "./Rows";
import { risks, rows } from "./Content";

export default function RisksAndRows({
  colors,
  activeRisk,
  selectRisk,
  activeRows,
  selectRows,
  handleAbove,
  audio,
}: any) {
  return (
    <Container backgroundColor={colors.primaryBackgroundLight}>
      <h2 style={{ marginBottom: 30, fontSize: 26, width: 315 }}>
        {"RISK & ROWS"}
      </h2>
      <Risks
        title="Risk"
        active={activeRisk}
        selectRisk={selectRisk}
        buttons={risks}
      />
      <Rows
        title="Rows"
        active={activeRows}
        selectRows={selectRows}
        buttons={rows}
      />
      <div style={{ marginTop: 90, color: colors.primaryBackground }}>
        <Button
          color={colors.primaryBackground}
          width="100%"
          func={() => handleAbove(false)}
          audio={audio}
          SFX={SFXS.confirmSFX}
        >
          OK
        </Button>
      </div>
    </Container>
  );
}
